import React from 'react';
import Hero from '../components/Hero';

const Home: React.FC = () => {
  return (
    <div className="space-y-0">
      <Hero />
      {/* <Stats /> */}
      {/* <Features /> */}
      {/* <Newsletter /> */}
    </div>
  );
};

export default Home;